module.exports = __webpack_public_path__ + "static/media/status_pink.bfd4503f.svg";